import { fetchBlobFromUrl } from '../../utils/upload'

export async function decodeAudioWaveform(url, audioContext) {
  const blob = await fetchBlobFromUrl(url)
  if (!blob) throw new Error('missing blob')
  const arrayBuffer = await blob.arrayBuffer()
  const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
  const channelData = audioBuffer.getChannelData(0)
  const samples = 200
  const blockSize = Math.max(1, Math.floor(channelData.length / samples))
  const peaks = []
  for (let index = 0; index < samples; index += 1) {
    let sum = 0
    for (let offset = 0; offset < blockSize; offset += 1) {
      sum += Math.abs(channelData[index * blockSize + offset] || 0)
    }
    peaks.push(sum / blockSize)
  }
  const max = Math.max(...peaks, 1)
  return {
    audioData: arrayBuffer.slice(0),
    waveform: peaks.map((peak) => peak / max),
    duration: audioBuffer.duration,
  }
}

export function audioBufferToWav(buffer) {
  const numChannels = buffer.numberOfChannels
  const sampleRate = buffer.sampleRate
  const bitDepth = 16
  const bytesPerSample = bitDepth / 8
  const blockAlign = numChannels * bytesPerSample
  const dataLength = buffer.length * blockAlign
  const arrayBuffer = new ArrayBuffer(44 + dataLength)
  const view = new DataView(arrayBuffer)
  const writeString = (offset, value) => {
    for (let index = 0; index < value.length; index += 1) {
      view.setUint8(offset + index, value.charCodeAt(index))
    }
  }
  writeString(0, 'RIFF')
  view.setUint32(4, 36 + dataLength, true)
  writeString(8, 'WAVE')
  writeString(12, 'fmt ')
  view.setUint32(16, 16, true)
  view.setUint16(20, 1, true)
  view.setUint16(22, numChannels, true)
  view.setUint32(24, sampleRate, true)
  view.setUint32(28, sampleRate * blockAlign, true)
  view.setUint16(32, blockAlign, true)
  view.setUint16(34, bitDepth, true)
  writeString(36, 'data')
  view.setUint32(40, dataLength, true)
  const channels = Array.from({ length: numChannels }, (_, index) => buffer.getChannelData(index))
  let outputOffset = 44
  for (let index = 0; index < buffer.length; index += 1) {
    for (let channel = 0; channel < numChannels; channel += 1) {
      const sample = Math.max(-1, Math.min(1, channels[channel][index]))
      view.setInt16(outputOffset, sample < 0 ? sample * 0x8000 : sample * 0x7fff, true)
      outputOffset += 2
    }
  }
  return new Blob([arrayBuffer], { type: 'audio/wav' })
}
